import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PeriodFilter } from '@/types';

interface AppState {
  activeOperation: string | null;
  periodFilter: PeriodFilter;
  isDarkMode: boolean;
  isInitialized: boolean;
  setActiveOperation: (id: string | null) => void;
  setPeriodFilter: (filter: PeriodFilter) => void;
  toggleDarkMode: () => void;
  setInitialized: (value: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      activeOperation: null,
      periodFilter: 'all',
      isDarkMode: false,
      isInitialized: false,
      setActiveOperation: (id) => set({ activeOperation: id }),
      setPeriodFilter: (filter) => set({ periodFilter: filter }),
      toggleDarkMode: () =>
        set((state) => {
          const newMode = !state.isDarkMode;
          document.documentElement.classList.toggle('dark', newMode);
          return { isDarkMode: newMode };
        }),
      setInitialized: (value) => set({ isInitialized: value }),
    }),
    {
      name: 'app-state',
      partialize: (state) => ({
        activeOperation: state.activeOperation,
        periodFilter: state.periodFilter,
        isDarkMode: state.isDarkMode,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.isDarkMode) {
          document.documentElement.classList.add('dark');
        }
      },
    }
  )
);
